module.exports = __webpack_public_path__ + "01_short_beige.01f8febd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/01_short_beige.png
// module id = gn+V
// module chunks = 0